// import { poof } from './confetti.js';

function isFriend() {
	let friend = false;
	if (!!localStorage.getItem('isFriend') === true) {
		friend = true;
	}
	return friend;
}

function isFriendSaleActive() {
	return !!customData.isFriendSaleActive;
}

function rememberFriend() {
	localStorage.setItem('isFriend', true);
}

function forgetFriend() {
	localStorage.removeItem('isFriend');
}

function isNewFriend() {
	let key = '?vriendenverkoop23-24';
	if (isFriend()) {
		return false;
	}
	if (window.location.toString().indexOf(key) > 0) {
		return true;
	}
	return false;
}

function showFriendTicketButtons() {
	if (document.body.contains(document.querySelector('.btn--friend-sale'))) {
		document.querySelectorAll('.btn--friend-sale').forEach(function (el, i) {
			el.classList.toggle('hide');
		});
	}
}

function hideRegularTicketButtons() {
	if (document.body.contains(document.querySelector('.btn--regular-sale'))) {
		document.querySelectorAll('.btn--regular-sale').forEach(function (el, i) {
			el.classList.toggle('hide');
		});
	}
}

function showTicketButtons() {
	if (isFriendSaleActive()) {
		hideRegularTicketButtons();
		showFriendTicketButtons();
	}
}

function sayHi() {
	console.log('Hi, friend!');
}

function showConfetti() {
	poof();
}

// actions triggered the first time the correct friend page is visited
function doFriendFirstTimeActions() {
	sayHi();
	rememberFriend();
	// showConfetti();
	showTicketButtons();
}

// actions always triggered, after a friend has been acknowledged
function doFriendAlwaysActions() {
	showTicketButtons();
	sayHi();
}


if (isNewFriend()) {
	doFriendFirstTimeActions()
}

if (isFriend()) {
	doFriendAlwaysActions();
}

